import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getMovement,
  getIdMovement,
  createMovement,
  updateMovement,
  deleteMovement,
  updateMovementSetStatus,
  updateMovementConfirm,
  updateMovementCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteMovementVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  getTransportations,
  createTransportations,
  updateTransportations,
  deleteTransportations,
  updateMovementStartWorkFlow,
  uploadMovement,
  updateMovementAmend,
  uploadPicking,
  uploadBTS,
  uploadMovementWorkflow,
  updateMovementAmmend,
  updateMovementComplete,
  getGenerateExcelBlob
} from "./movementAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,

  permissionsMovement: [],
  permissionsList: [],
};

export const fetchMovement = createAsyncThunk(
  "Movement/fetchMovement",
  async (payload) => {
    const response = await getMovement(payload);
    return response;
  }
);

export const addMovement = createAsyncThunk(
  "Movement/addMovement",
  async (payload) => {
    const response = await createMovement(payload);
    return response;
  }
);

export const editMovement = createAsyncThunk(
  "Movement/editMovement",
  async (payload) => {
    const response = await updateMovement(payload);
    return response;
  }
);

export const editMovementConfirm = createAsyncThunk(
  "Movement/editMovementConfirm",
  async (payload) => {
    const response = await updateMovementConfirm(payload);
    return response;
  }
);
export const editMovementAmmend = createAsyncThunk(
  "Movement/editMovementAmmend",
  async (payload) => {
    const response = await updateMovementAmmend(payload);
    return response;
  }
);

export const editMovementComplete = createAsyncThunk(
  "Movement/editMovementComplete",
  async (payload) => {
    const response = await updateMovementComplete(payload);
    return response;
  }
);

export const editMovementCancel = createAsyncThunk(
  "Movement/editMovementCancel",
  async (payload) => {
    const response = await updateMovementCancel(payload);
    return response;
  }
);

export const editMovementStarWorkflow = createAsyncThunk(
  "Movement/editMovementStarWorkflow",
  async (payload) => {
    const response = await updateMovementStartWorkFlow(payload);
    return response;
  }
);

export const fetchIdMovement = createAsyncThunk(
  "Movement/fetchIdMovement",
  async (id) => {
    const response = await getIdMovement(id);
    return response;
  }
);

export const removeMovement = createAsyncThunk(
  "Movement/removeMovement",
  async (payload) => {
    const response = await deleteMovement(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "Movement/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadMovement(id, file);
    return response;
  }
);

export const AddUploadFileMovement = createAsyncThunk(
  "Movement/AddUploadFileMovement",
  async ({ id, file }) => {
    const response = await uploadMovementWorkflow(id, file);
    return response;
  }
);
export const AddUploadFileBTS = createAsyncThunk(
  "Movement/AddUploadFileBTS",
  async ({ id, file }) => {
    const response = await uploadBTS(id, file);
    return response;
  }
);

// vihicle
export const fetchMovementVehicle = createAsyncThunk(
  "Movement/fetchMovementVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addMovementVehicle = createAsyncThunk(
  "Movement/addMovementVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);
export const removeMovementVehicle = createAsyncThunk(
  "Movement/removeMovementVehicle",
  async (payload) => {
    const response = await deleteMovementVehicles(payload);
    return response;
  }
);

export const editMovementVehicle = createAsyncThunk(
  "Movement/editMovementVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

// party
export const fetchMovementParty = createAsyncThunk(
  "Movement/fetchMovementParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchMovementPartyAll = createAsyncThunk(
  "Movement/fetchMovementPartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addMovementParty = createAsyncThunk(
  "Movement/addMovementParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editMovementParty = createAsyncThunk(
  "Movement/editMovementParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeMovementParty = createAsyncThunk(
  "Movement/removeMovementParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "Movement/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

export const movementSlice = createSlice({
  name: "movement",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermisionMovement: (state, action) => {
      state.permissionsMovement = action.payload;
    },
    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementAmmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementAmmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementStarWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementStarWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileBTS.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileBTS.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchMovementVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMovementVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addMovementVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMovementVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMovementVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMovementVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMovementVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMovementVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected,setPermisionList,setPermisionMovement } = movementSlice.actions;

export const selectMovement = (state) => state.movement.data;
export const selectMovementVehicle = (state) => state.movement.data;
export const selectIdMovement = (state) => state.movement.dataId;
export const selectLoading = (state) => state.movement.loading;
export const selectError = (state) => state.movement.error;
export const selectPageNo = (state) => state.movement.pageNo;
export const selectPageSize = (state) => state.movement.pageSize;
export const selectTotalRecord = (state) => state.movement.totalRecord;
export const selectSelected = (state) => state.movement.selected;
export const selectResult = (state) => state.movement.result;
export const selectPermissionMovement = (state) => state.movement.permissionsMovement;
export const selectPermissionList = (state) => state.movement.permissionsList;

export default movementSlice.reducer;
